import { jsx as _jsx } from "react/jsx-runtime";
// Copyright 2022 The Parca Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import { Input } from '../';
import { useEffect, useMemo } from 'react';
import { useAppDispatch, setSearchNodeString } from '@parca/store';
import useUIFeatureFlag from '@parca/functions/useUIFeatureFlag';
import { debounce } from 'lodash';
var SearchNodes = function () {
    var dispatch = useAppDispatch();
    var filterByFunctionEnabled = useUIFeatureFlag('filterByFunction')[0];
    useEffect(function () {
        return function () {
            debouncedSearch.cancel();
        };
    });
    var debouncedSearch = useMemo(function () {
        var handleChange = function (event) {
            dispatch(setSearchNodeString(event.target.value));
        };
        return debounce(handleChange, 300);
    }, [dispatch]);
    return (_jsx("div", { children: _jsx(Input, { className: "text-sm", placeholder: filterByFunctionEnabled ? 'Highlight nodes...' : 'Search nodes...', onChange: debouncedSearch }) }));
};
export default SearchNodes;
